import { render } from "@/components/pages/individualWorkSupport/REQ-04/50004/Requirement50004.html?vue&type=template&id=e1bc0a3a&external"
import script from "@/components/pages/individualWorkSupport/REQ-04/50004/Requirement50004.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/REQ-04/50004/Requirement50004.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__